import { Link } from 'react-router-dom';
import React from 'react';

const ThankYou = () => {
  return (
    <div className="container">
      <section className="header">
        <h2>Thank you for your submission!</h2>
      </section>
      <p>Your technology due diligence assessment has been submitted successfully.</p>
      <p>The information you've provided will help us understand your technology organization and infrastructure better. Our team will review your responses and may reach out for additional information or clarification if needed.</p>
      <p>If you have any questions or need to update your submission, please contact the due diligence team directly.</p>
      <Link to="/" className="back-link">Return to the main page</Link>
    </div>
  );
};

export default ThankYou;
